import Backdrop from "@mui/material/Backdrop"

const ModalBackdrop = (props) => {
  return (
    <Backdrop open sx={{ zIndex: 999, backgroundColor: '#d6d6d649' }}>
      {props.children}
    </Backdrop>

  )
}

export default ModalBackdrop